module.exports = __webpack_public_path__ + "img/two_.5ffbfdac.png";